import React from 'react'

import BaseButton from '../base'
import { BaseButtonProps } from '../base/base-button.component'

import * as styles from './outline.module.css'

const OutlineButton: React.FC<BaseButtonProps> = ({ children, ...props }) => (
  <BaseButton styles={styles} {...props}>
    {children}
  </BaseButton>
)

export default OutlineButton
